import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/prioridade`

    return {
        index(queryParms) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        show(id) {
            return repository.get(`${baseUrl}/${id}`)
        },
        edit(id) {
            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id, params) {
            return repository.put(`${baseUrl}/${id}`, params)
        },
        destroy(id) {
            return repository.delete(`${baseUrl}/${id}`)
        },
    }
}